import React from "react";
import { useDispatch } from "react-redux";
import { openModal } from "../actions";
import { deleteUser } from "../firebase";
import { Table, Icon } from "semantic-ui-react";

const User = ({ user }) => {
  const dispatch = useDispatch();

  const handleEdit = (person) => {
    dispatch(
      openModal("UserModal", {
        centered: false,
        userRecord: person,
      })
    );
  };

  const removeUser = (person) => {
    const conf = window.confirm(
      `Please confirm you want to delete ${person.displayName}.`
    );
    if (conf) {
      deleteUser(person.id).then(
        () => {
          console.log(person.displayName, "deleted");
        },
        (error) => {
          console.log(error);
        }
      );
    }
  };

  return (
    <Table.Row>
      <Table.Cell>{user.displayName}</Table.Cell>
      <Table.Cell>
        <i className="mute">{user.email}</i>
      </Table.Cell>
      <Table.Cell>{user.organisation}</Table.Cell>
      <Table.Cell>
        {user.isViewer && <Icon name="check" color="green" />}
      </Table.Cell>
      <Table.Cell>
        {user.isEditor && <Icon name="check" color="green" />}
      </Table.Cell>
      <Table.Cell>
        {user.isAdOps && <Icon name="check" color="green" />}
      </Table.Cell>
      <Table.Cell>
        {user.isAdmin && <Icon name="check" color="green" />}
      </Table.Cell>
      <Table.Cell>
        {user.restrictByRetailer && <Icon name="check" color="green" />}
      </Table.Cell>
      <Table.Cell>{user.retailer}</Table.Cell>
      <Table.Cell>
        {user.restrictByAdvertiser && <Icon name="check" color="green" />}
      </Table.Cell>
      <Table.Cell>{user.advertiser && user.advertiser.join(", ")}</Table.Cell>
      <Table.Cell>
        <Icon
          name="edit"
          className="pointer"
          onClick={() => handleEdit(user)}
          size="large"
          color="blue"
        />
      </Table.Cell>
      <Table.Cell>
        <Icon
          name="trash"
          className="pointer"
          onClick={() => removeUser(user)}
          size="large"
          color="red"
        />
      </Table.Cell>
    </Table.Row>
  );
};

export default User;
